import { ButtonSize } from "components/ComponentsType";
import Button from "components/ui/Button";
import TabMenu from "components/ui/TabMenu";
import { Fragment, useCallback, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { ElementGroup, LeftTableContainer, TableContainer } from "styles/components";
import Grid from "commons/ui/grid/Grid";
import type { IGridSetting, IGrideCell } from "commons/ui/grid/GridVo";
import Papa from "papaparse";
import {
  useCalculateTabAction,
  useContentsTabListInit,
  useContentsTabListLoad,
  useDataBtnClickAction,
  useExcelLoadBtnAction,
  useExpectPageInit,
  useFileReadHook,
  useMonthList,
  useNowYearSelectBox,
  useOptionListInit,
  useRatioNumberCheck,
  useSaveFlag,
  useSearchDateAction,
  useSettlementDataLoad,
  useSettlementPageInit,
  useSubTabAction,
  useTaxSelectChange,
} from "../store/CalculateHook";
import { UiCheckBox } from "commons/components/CheckBox";
import GridEmpty from "components/grid/GridEmpty";
import { UiSelectBox } from "components/ui/SelectBox";
import ButtonTabMenu from "components/ui/ButtonTabMenu";
import {
  ActiveType,
  type IContentsChannelGirdListVo,
  type IGridRowUpdateData,
  type ISettlementListVo,
} from "../store/CalculateVo";
import { useSelectBoxValue, useSetSelectBox } from "commons/ui/reUi/useUihook";
import { type FileType } from "commons/ui/uiVo";
import { UiInputFile } from "components/ui/InputFile";
import SVG from "commons/styles/svgIcon";

import { useAlarmtalkPopup } from "components/popup/alarmtalk/AlarmtalkHook";
import Pagelable from "components/ui/Pagelable";
import { useDispatch } from "react-redux";
import TagLabel from "components/ui/TagLabel";
import {
  rdxRemoveSelectChannelList,
  rdxResetSaveFlag,
  rdxSetCalculateGridRowUpdate,
  rdxSetSaveFlag,
  rdxSetSelectChannelList,
} from "../store/CalculateR";
import { GridLocalStringCell } from "components/grid/GridCell";
import InputText from "commons/components/InputText";
import { UiInputDate } from "components/ui/InputDate";
import UiInputText from "commons/components/ui/UiInputText";

import moment from "moment";
import { GridDateCell, GridLeftTextCell } from "commons/ui/grid/AbsGridCell";
import { useCalculateRatioPopup, useGetCheckChannelList } from "components/popup/calculateRatio/calculateRatioHook";
import { useGridCheckBoxValue } from "commons/ui/useGrid";
import { useAlert, useIConPopup } from "components/popup/popupHook";
import { useParams } from "react-router-dom";
import NotFound from "pages/404";
import { NumberCountAnimation } from "pages/provider/page/home";
import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";
import { useInputText, useSetInput } from "commons/ui/useUihook";

/**
 * uiux 리뉴얼 탭메뉴
 */
export const NewTabMenuStyle = styled.div`
  width: 100%;
  ul {
    border-bottom: 1.5px solid #e4e8e8;
    li {
      margin: 0 40px 0 0;
      button {
        border: none;
        background: #fff;
        color: #999999;
        padding-bottom: 10px;
        font-weight: 600;

        &.is-active {
          color: #444444;
          border-bottom: 2px solid #2c3030;
        }
        span {
          display: none;
        }
      }
    }
  }
`;

const GridWrapper = styled.div`
  width: 100%;
  position: relative;
  table {
    width: 100%;
    box-sizing: border-box;
    * {
      font-size: 1rem;
    }
  }
`;

const SelectDateWrap = styled.div`
  /* justify-content: space-between; */
  display: flex;
  div:first-child {
    margin-right: 15px;
    font-size: 15px;
  }
`;

const TotalDataWrap = styled(ElementGroup.Row)<{ liCount: number }>`
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;

  .total-data-text__ul {
    display: flex;
    font-size: 1.13rem;
    font-weight: 500;
    width: 100%;
    gap: 10px;
    li {
      width: ${props => `calc(100% / ${props.liCount})`};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      border-radius: 8px;
      background: #f7f9f9;
      padding: 25px 20px;

      span:first-child {
        color: #7c8484;
        font-size: 1rem;
        margin-bottom: 4px;
      }
      span:last-child {
        color: #161c1c;
        font-weight: 600;
        font-size: 1.5rem;
      }
    }
  }
`;

const OptionHeader = styled.div<{ align?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${props => (props.align ? "row" : "column")};
  margin: 20px 0;
  justify-content: space-between;
  position: relative;
  .channel-select-items {
    margin-left: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    div {
      margin-right: 4px;
    }
  }
`;

const GridInputWrap = styled.div`
  width: auto;
  .channel-checkbox {
    label {
      white-space: break-spaces;
      overflow-x: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
  }

  input {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #dedede;
    border-right: none;
    border-top: none;
    border-left: none;
    border-radius: 0;

    &.red {
      color: var(--font-red);
    }
    &[type="number"] {
      text-align: right;
    }
    &[type="text"] {
      white-space: break-spaces;
      overflow-x: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    &::placeholder {
      color: #b4b4b4;
      /* text-align: center; */
    }
  }
`;

const ExcelLoadBtnWrapper = styled.div<{ tab: string }>`
  position: relative;
  display: flex;
  align-items: center;
  input {
    display: none;
  }

  button {
    border: 1px solid var(--border-normal);
    line-height: 36px;
    font-size: 1rem;
    border-radius: 8px;
    background-color: #fff !important;

    &::before {
      content: "";
      display: inline-block;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 24px;
      width: 24px;
      height: 24px;
      margin-right: 5px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M14.625 19.5C14.625 19.6989 14.546 19.8897 14.4053 20.0303C14.2647 20.171 14.0739 20.25 13.875 20.25H11.25C11.0511 20.25 10.8603 20.171 10.7197 20.0303C10.579 19.8897 10.5 19.6989 10.5 19.5V14.25C10.5 14.0511 10.579 13.8603 10.7197 13.7197C10.8603 13.579 11.0511 13.5 11.25 13.5C11.4489 13.5 11.6397 13.579 11.7803 13.7197C11.921 13.8603 12 14.0511 12 14.25V18.75H13.875C14.0739 18.75 14.2647 18.829 14.4053 18.9697C14.546 19.1103 14.625 19.3011 14.625 19.5ZM8.68592 13.6397C8.60578 13.5824 8.51514 13.5415 8.41918 13.5193C8.32323 13.4971 8.22384 13.494 8.12668 13.5102C8.02953 13.5264 7.93651 13.5615 7.85295 13.6137C7.76939 13.6658 7.69692 13.7339 7.63967 13.8141L6.37498 15.585L5.1103 13.8141C5.05509 13.7291 4.98324 13.6562 4.89909 13.5998C4.81495 13.5434 4.72024 13.5046 4.62069 13.4858C4.52114 13.467 4.41882 13.4686 4.31988 13.4904C4.22095 13.5122 4.12747 13.5538 4.04507 13.6128C3.96268 13.6717 3.89308 13.7468 3.84047 13.8333C3.78787 13.9199 3.75335 14.0163 3.739 14.1166C3.72466 14.2168 3.73078 14.319 3.75699 14.4169C3.78321 14.5147 3.82898 14.6063 3.89155 14.6859L5.45342 16.875L3.88967 19.0641C3.78443 19.226 3.74571 19.4223 3.78156 19.612C3.81742 19.8018 3.92509 19.9704 4.08215 20.0828C4.23922 20.1951 4.43357 20.2426 4.62474 20.2152C4.81591 20.1879 4.98916 20.0878 5.10842 19.9359L6.37498 18.165L7.63967 19.9359C7.75893 20.0878 7.93219 20.1879 8.12336 20.2152C8.31453 20.2426 8.50888 20.1951 8.66594 20.0828C8.82301 19.9704 8.93068 19.8018 8.96653 19.612C9.00239 19.4223 8.96366 19.226 8.85842 19.0641L7.29655 16.875L8.8603 14.6859C8.91755 14.6058 8.95845 14.5152 8.98067 14.4192C9.00289 14.3232 9.00599 14.2239 8.9898 14.1267C8.97361 14.0295 8.93844 13.9365 8.8863 13.853C8.83416 13.7694 8.76607 13.6969 8.68592 13.6397ZM17.9615 16.0603C17.5865 15.9516 17.1984 15.84 16.9819 15.7003C16.8647 15.6234 16.8665 15.6066 16.8769 15.5222C16.8783 15.454 16.896 15.3872 16.9287 15.3273C16.9613 15.2674 17.0078 15.2163 17.0644 15.1781C17.4956 14.8856 18.5025 15.0169 18.9225 15.1256C19.1149 15.1762 19.3196 15.1483 19.4915 15.048C19.6633 14.9477 19.7883 14.7832 19.8389 14.5908C19.8895 14.3983 19.8616 14.1937 19.7613 14.0218C19.661 13.8499 19.4965 13.725 19.304 13.6744C19.1062 13.6228 17.3353 13.185 16.2262 13.9331C15.9924 14.0911 15.796 14.2986 15.6511 14.5407C15.5061 14.7829 15.416 15.0539 15.3872 15.3347C15.1997 16.8234 16.6669 17.2481 17.5434 17.5012C18.674 17.8284 18.7734 17.9625 18.7415 18.2128C18.7125 18.4388 18.6234 18.525 18.54 18.5812C18.1087 18.8681 17.1187 18.7266 16.7081 18.6141C16.516 18.5607 16.3106 18.5859 16.1371 18.684C16.0512 18.7326 15.9757 18.7976 15.9149 18.8753C15.8541 18.9531 15.8092 19.0421 15.7828 19.1372C15.7564 19.2323 15.749 19.3317 15.761 19.4296C15.773 19.5276 15.8041 19.6223 15.8527 19.7082C15.9508 19.8817 16.1138 20.0092 16.3059 20.0625C16.7708 20.185 17.2493 20.248 17.73 20.25C18.2756 20.25 18.8831 20.1562 19.3697 19.8319C19.6097 19.6722 19.8114 19.4614 19.9602 19.2145C20.109 18.9676 20.2012 18.6909 20.2303 18.4041C20.4375 16.7812 18.8887 16.3284 17.9615 16.0603ZM3.74998 10.5V3.75C3.74998 3.35218 3.90802 2.97064 4.18932 2.68934C4.47063 2.40804 4.85216 2.25 5.24998 2.25H14.25C14.3485 2.24992 14.4461 2.26926 14.5371 2.3069C14.6282 2.34454 14.7109 2.39975 14.7806 2.46938L20.0306 7.71938C20.1002 7.78908 20.1554 7.87182 20.1931 7.96286C20.2307 8.05391 20.2501 8.15148 20.25 8.25V10.5C20.25 10.6989 20.171 10.8897 20.0303 11.0303C19.8897 11.171 19.6989 11.25 19.5 11.25C19.3011 11.25 19.1103 11.171 18.9697 11.0303C18.829 10.8897 18.75 10.6989 18.75 10.5V9H14.25C14.0511 9 13.8603 8.92098 13.7197 8.78033C13.579 8.63968 13.5 8.44891 13.5 8.25V3.75H5.24998V10.5C5.24998 10.6989 5.17097 10.8897 5.03031 11.0303C4.88966 11.171 4.6989 11.25 4.49998 11.25C4.30107 11.25 4.11031 11.171 3.96965 11.0303C3.829 10.8897 3.74998 10.6989 3.74998 10.5ZM15 7.5H17.6887L15 4.81031V7.5Z' fill='%23444444'/%3E%3C/svg%3E");
    }
  }
  .excel-load {
    button {
      &:last-child {
        color: #606060;
        margin-left: 5px;
      }
    }
  }
`;

const ChannelSelectboxWrapper = styled.div`
  display: flex;
`;

const OptionBtnWrapper = styled.div`
  display: flex;
  justify-content: end;
  button {
    margin-left: 5px;
    border-radius: 8px;
    border: 1px solid var(--border-normal);
    background: #fff;
    color: #444;
    line-height: 38px;
    &:hover:not(:disabled) {
      background-color: #fff;
      border: 1px solid var(--secondary);
      color: var(--secondary);
    }

    &:disabled {
      background-color: #dfdfdf;
      border: none;
      color: var(--font-disabled);
    }
  }

  button.media-excel-publish-btn {
    background: var(--secondary);
    color: #fff;
    &:hover:not(:disabled) {
      background-color: #fff;
      border: 1px solid var(--secondary);
      color: var(--secondary);
    }

    &:disabled {
      background-color: #dfdfdf;
      border: none;
      color: var(--font-disabled);
    }
  }
`;

const OptionDataButtonsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 10px 0;
  gap: 8px;
`;
export const numberComma = (num: number) => {
  return num ? num.toLocaleString("ko-kr") : 0;
};

/**
 * 정산 커스텀 테이블
 */
const CalculateTableWrapper = styled.div`
  position: relative;
  .table-wrap {
    position: relative;
    width: 100%;
    height: 67vh;
    overflow-y: scroll;
  }
  table.grid-data-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    thead {
      tr {
        th {
          position: sticky;
          top: 0;
          z-index: 5;
          background-color: #f7f9f9;
          padding: 10px 4px;
          color: #7c8484;
          font-weight: 500;
          text-align: left;
        }
      }
    }
    tbody {
      position: relative;
      tr {
        width: 100%;
        td {
          border-bottom: 1px solid var(--border-normal);
          padding: 0 8px;
          text-align: left;
          vertical-align: middle;

          &:first-child {
            border-left: none;
            border-right: 1px solid var(--border-normal);
          }
          &:last-child {
            border-right: none;
          }

          .td-detail {
          }
        }
        td.colSpan {
          padding: 8px 0 8px 8px;
          border-right: 1px solid var(--border-normal);

          .td-detail {
            display: flex;
            align-items: center;
            justify-content: space-between;
            > div {
              flex: 1;
              text-align: left;
              padding: 8px 0;
            }
          }
        }
      }
    }
  }
`;
const TotalTableRow = styled.div`
  width: 100%;
  border-top: 1px solid #7c8484;
  background: var(--box_gray, #f7f9f9);
  position: sticky;
  z-index: 1;
  bottom: 0;
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    td {
      &:first-child {
        text-align: center;
      }
      color: #161c1c;
      font-weight: 600;
      border: none;
      padding: 0;
      border-bottom: 1px solid var(--border-normal);
      padding: 18px 0;
      text-align: left;
      vertical-align: middle;
    }
  }
`;

const TableInputWrap = styled.div`
  div {
    border-radius: 4px;
    border: 1px solid var(--border-normal);
    display: flex;
    align-items: center;
    width: 80%;
    padding: 0 8px;
    input {
      width: 100%;
      padding: 0;
      border: none;

      &.red {
        color: #ff0000;
      }
      &.ratio::after {
        content: "%";
      }
    }
  }
`;

const TableInputWrapMemo = styled.div<{ mark: boolean }>`
  position: relative;
  div {
    position: relative;
    border-radius: 4px;
    border: 1px solid var(--border-normal);
    display: flex;
    align-items: center;
    width: 80%;
    padding: 0 8px;

    ${props =>
      props.mark === true &&
      `&::after {
      content: "◥";
      font-size: 0.8rem;
      position: absolute;
      color: #018825;
      top: -5px;
      right: 0;
    }`}

    input {
      width: 100%;
      padding: 0;
      border: none;
    }
  }
`;

const StatusTd = styled.td<{ type: string }>`
  .select-box {
    span {
      color: ${props => (props.type === "ok" ? "#1079F4" : props.type === "not" ? "#E65F3E" : "#161C1C")};
    }
  }
`;

function GridLocalStringRightTextCell(props: { value?: number }): JSX.Element {
  return <div>{props.value !== undefined ? Number(props.value).toLocaleString("ko-kr") : 0}</div>;
}

/**
 * 채널명 체크박스 Grid
 * @param props IGrideCell<[string]> {@link IGrideCell}
 * @returns JSX.Element
 */
function GridCheckboxCell(props: IGrideCell<[string, string]>): JSX.Element {
  const { setTotalGridValue } = useGridCheckBoxValue();
  const gridAllCheck = (value?: boolean) => {
    setTotalGridValue(value!);
  };

  return (
    <GridInputWrap>
      <div className="channel-checkbox">
        {props.data[0] === "all" ? (
          <UiCheckBox id="isAll" name="gridAllCheckbox" change={gridAllCheck} text={props.data[1]} />
        ) : (
          <UiCheckBox
            id={props.data[0] === "all" ? "all" : `${props.data[0]}_${props.data[1]}`}
            name="gridAllCheckbox"
            change={gridAllCheck}
            text={props.data[1]}
          />
        )}
      </div>
    </GridInputWrap>
  );
}

/**
 * 그리드 리스트 요율 입력 부분
 * @param props 코드, 요율
 * @returns
 */
// function GridRatioStringCell(props: IGrideCell<[string, number | string]>): JSX.Element {
function GridRatioStringCell(props: { data: IGridRowUpdateData }): JSX.Element {
  const dispatch = useDispatch();
  const [ratio, setRatio] = useState<string | undefined>(String(props.data.value));

  const changeRatio = (v?: string) => {
    setRatio(v ? v : "0");
    dispatch(
      rdxSetCalculateGridRowUpdate({
        user_id: props.data.user_id,
        code: props.data.code,
        row_num: props.data.row_num,
        type: "ratio",
        value: v ? v : 0,
      }),
    );
  };
  return (
    <>
      <TableInputWrap>
        <div>
          <UiInputText
            type="number"
            className={`ratio ${Number(ratio) > 99 ? "red" : ""}`}
            id={`${props.data.code}_ratio_input`}
            placeholder="요율"
            init={String(props.data.value)}
            value={ratio}
            change={v => changeRatio(v.value)}
          />
          %
        </div>
      </TableInputWrap>
    </>
  );
}

/**
 * 추가 정산금 값 입력해야하는 cell
 * @param props IGrideCell<[string, number]> {@link IGrideCell}
 * @returns JSX.Element
 */
function GridInputSaleDataCell(props: { data: IGridRowUpdateData }): JSX.Element {
  const dispatch = useDispatch();
  return (
    <>
      <TableInputWrap>
        <div>
          <InputText
            type="number"
            placeholder="추가 금액 입력"
            value={String(props.data.value)}
            change={v =>
              dispatch(
                rdxSetCalculateGridRowUpdate({
                  user_id: props.data.user_id,
                  code: props.data.code,
                  row_num: props.data.row_num,
                  type: "add",
                  value: v.value,
                }),
              )
            }
          />
          원
        </div>
      </TableInputWrap>
    </>
  );
}

/**
 * 메모 입력해야하는 cell
 * @param props IGrideCell<[string, number]> {@link IGrideCell}
 * @returns JSX.Element
 */
// function GridInputMemoCell(props: IGrideCell<[string, string]>): JSX.Element {
function GridInputMemoCell(props: { subTab: string; id: number; memo: string }): JSX.Element {
  const dispatch = useDispatch();
  return (
    <>
      <TableInputWrapMemo
        mark={props.memo !== null && props.memo !== undefined && props.memo.length > 0 ? true : false}
      >
        <div>
          <InputText
            type="text"
            placeholder="메모 입력"
            value={props.memo ? props.memo : ""}
            change={v => {
              dispatch(rdxSetSaveFlag(props.subTab));
              dispatch(rdxSetCalculateGridRowUpdate({ user_id: props.id, type: "memo", value: v.value }));
            }}
          />
        </div>
      </TableInputWrapMemo>
    </>
  );
}

/**
 * 서브 탭 - 예상수익 일자 달력
 * @returns
 */
function CalendarDateSearchOption(props: { tab: string }): JSX.Element {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 3);

  return (
    <SelectDateWrap>
      <UiInputDate id={`${props.tab}_Calendar_Date`} init={moment(yesterday).format("YYYY-MM-DD")}></UiInputDate>
    </SelectDateWrap>
  );
}

/**
 * 채널 리스트 옵션 wrap
 * @param props
 * @returns
 */
function ChannelSearchOption(props: { tab: string; subTab: string }): JSX.Element {
  const dispatch = useDispatch();
  const { optionList, selectChannel } = useOptionListInit(props.tab);

  return (
    <ElementGroup.Row flexContent="between" style={{ width: "100%" }}>
      {/* 채널 선택 */}
      <ChannelSelectboxWrapper>
        <UiSelectBox
          id={`${props.tab}_${props.subTab}_ChannelList`}
          data={optionList ? optionList : []}
          placeholder="채널 선택"
          isClear={false}
          init={"all"}
          search
          size="md"
          selectId="id"
          selectType="id"
          displayType="new"
          change={(val?: number | string) => {
            if (val !== undefined) {
              dispatch(
                rdxSetSelectChannelList({
                  id: optionList![val as number].value as number,
                  text: optionList![val as number].text,
                }),
              );
            }
          }}
        />
        <div className="channel-select-items">
          {selectChannel && selectChannel[props.tab] && Object.keys(selectChannel[props.tab]).length > 0 ? (
            selectChannel[props.tab].map(item => {
              return (
                <TagLabel
                  key={item.id}
                  text={item.text}
                  onClick={() => {
                    dispatch(rdxRemoveSelectChannelList(item.id));
                  }}
                  useRemove
                />
              );
            })
          ) : (
            <TagLabel key={"all"} text={"#전체"} />
          )}
        </div>
      </ChannelSelectboxWrapper>

      <ExcelLoadBtnWrap tab={props.tab} subTab={props.subTab} />
    </ElementGroup.Row>
  );
}

/**
 * 엑셀 관련 버튼 action (엑셀 다운로드 및 불러오기)
 * @param props
 * @returns
 */
function ExcelLoadBtnWrap(props: { tab: string; subTab: string }): JSX.Element {
  const { dataSave, getDownloadExcel } = useExcelLoadBtnAction();
  const uploadFile = useFileReadHook();

  return (
    <ExcelLoadBtnWrapper tab={props.tab}>
      {props.tab === ActiveType.CON && (
        <Button
          className="excel-download-btn"
          btnType="border"
          btnSize={ButtonSize.SM}
          text="다운로드"
          thin
          onClick={() => {
            getDownloadExcel();
          }}
        />
      )}

      {((props.tab === ActiveType.CP && props.subTab === "msn") ||
        (props.tab === ActiveType.CON && props.subTab === "sales")) && (
        <div className="excel-load">
          <UiInputFile
            id={`${props.tab}_${props.subTab}_excel`}
            buttonText="불러오기"
            accept={".csv,.numbers,.xlsx"}
            change={(value: Array<FileType>) => {
              const val = value && value[0].file;
              Papa.parse(val!, {
                complete: function (results) {
                  if (props.tab === ActiveType.CP && props.subTab === "msn") {
                    dataSave();
                  }

                  if (props.tab === ActiveType.CON && props.subTab === "sales") {
                    uploadFile(results);
                  }
                },
              });
            }}
          />
        </div>
      )}
    </ExcelLoadBtnWrapper>
  );
}

/**
 * 그리드 리스트 관련 - 리스트 저장 / 정산 내역 발행 (요율 체크 필수)
 * @param props
 * @returns
 */
function ContentsSaveBtnWrap(props: { tab: string; subTab: string }): JSX.Element {
  const { saveFlag } = useSaveFlag(props.subTab);
  const { check, channel_name } = useRatioNumberCheck(props.subTab);
  const { dataSave } = useDataBtnClickAction();
  const alert = useAlert();
  const iconPopup = useIConPopup();

  return (
    <>
      {props.tab === ActiveType.CP && (
        <Button
          btnSize={ButtonSize.XSM}
          color={"dark"}
          text="저장"
          thin
          disabled={saveFlag === undefined || saveFlag === true ? true : false}
          onClick={() => {
            check
              ? dataSave("save")
              : alert(`요율은 100%를 초과할 수 없습니다.<br/>해당 채널을 확인해주세요.<br/><br/>${channel_name}`);
          }}
        />
      )}

      {props.tab !== ActiveType.CON && (
        <Button
          btnSize={ButtonSize.XSM}
          color={"blue"}
          text="정산 내역 발행"
          thin
          disabled={saveFlag === undefined || saveFlag === false ? true : false}
          onClick={() => {
            iconPopup(
              "confirm",
              {
                iconColor: "#cd3232",
                iconType: "Check",
                desc: "정산 발행 하시겠습니까?",
              },
              undefined,
              v => {
                if (v && v > 0) {
                  if (check) {
                    saveFlag === false ? alert("'저장'버튼을 누른 이후에 발행할 수 있습니다.") : dataSave("publish");
                  } else {
                    alert(`요율은 100%를 초과할 수 없습니다.<br/>해당 채널을 확인해주세요.<br/><br/>${channel_name}`);
                  }
                }
              },
            );
          }}
        />
      )}
    </>
  );
}

/**
 * 그리드 리스트 상단 년,월 select 영역
 * @param props
 * @returns
 */
function DateSearchOption(props: { tab: string; subTab: string }): JSX.Element {
  const { searchMonth, change, changeSelectBox } = useSearchDateAction(props.tab, props.subTab);
  const { selectValue } = useSelectBoxValue(`calculate_${props.tab}_${props.subTab}_search_year`);
  const { changeValue } = useSetSelectBox(`calculate_${props.tab}_${props.subTab}_search_year`);

  const now = new Date();
  const nowYear = now.getFullYear();
  const month = now.getMonth();

  const viewMonth = selectValue === String(nowYear) ? now.getMonth() + 1 : 12;
  const active = searchMonth ? String(searchMonth) : String(month);
  const { year, yearData } = useNowYearSelectBox(2023);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectValue) {
      changeValue(String(year));
    }
  }, [props.subTab]);

  return (
    <OptionDataButtonsWrap>
      {/* 날짜 선택 */}
      <SelectDateWrap>
        <UiSelectBox
          id={`calculate_${props.tab}_${props.subTab}_search_year`}
          data={yearData}
          selectId="value"
          selectType="id"
          size="sm"
          displayType="new"
          change={() => changeSelectBox(month + 1)}
          init={selectValue ? selectValue : String(year)}
        />
        <ButtonTabMenu
          list={useMonthList(viewMonth)}
          active={active === "0" ? "1" : active}
          click={val => {
            dispatch(rdxResetSaveFlag(props.subTab));
            change(active, val);
          }}
        />
      </SelectDateWrap>
      <OptionBtnWrap tab={props.tab} subTab={props.subTab} />
    </OptionDataButtonsWrap>
  );
}

function MediaExcelPublish() {
  const { excelViewList } = useSettlementPageInit();
  const { dataSave } = useDataBtnClickAction();
  const iconPopup = useIConPopup();

  return (
    <Button
      btnSize={ButtonSize.XSM}
      color={"dark"}
      text="정산 내역 발행"
      thin
      className="media-excel-publish-btn"
      disabled={excelViewList ? false : true}
      onClick={() => {
        iconPopup(
          "confirm",
          {
            iconColor: "#cd3232",
            iconType: "Check",
            desc: "정산 발행 하시겠습니까?",
          },
          undefined,
          v => {
            v && v > 0 && dataSave("excel");
          },
        );
      }}
    />
  );
}
/**
 * 리스트 상단에 보여질 옵션 버튼 영역
 * @param props
 * @returns ContentsSaveBtnWrap: 저장 및 발행하기 버튼 / ExcelLoadBtnWrap: 엑셀 관련 / 알림톡 보내기
 */
function OptionBtnWrap(props: { tab: string; subTab: string }): JSX.Element {
  const { showAlarmtalkPopup } = useAlarmtalkPopup();

  return (
    <OptionBtnWrapper>
      {/* {props.tab === ActiveType.CP || props.tab === ActiveType.PN ? (
        <ContentsSaveBtnWrap tab={props.tab} subTab={props.subTab} />
      ) : (
        <ExcelLoadBtnWrap tab={props.tab} subTab={props.subTab} />
      )} */}
      <ContentsSaveBtnWrap tab={props.tab} subTab={props.subTab} />
      {/* TODO : 요율 변경 버튼은 추후에 적용 */}
      {/* <RatioPopupWrap tab={props.tab} subTab={props.subTab} /> */}
      <Button
        btnSize={ButtonSize.XSM}
        text="알림톡 보내기"
        color={"dark"}
        thin
        onClick={() => {
          showAlarmtalkPopup("REVENUE", props.tab);
          // showAlarmtalkPopup("REVENUE", props.tab === ActiveType.CP ? "CP" : "PN");
        }}
      />
      {props.tab === ActiveType.CON && props.subTab === "sales" && <MediaExcelPublish />}
    </OptionBtnWrapper>
  );
}

/**
 * 콘텐츠 탭 > cp, msn 탭 일 경우 보여질 토탈 데이터 / 파트너스 데이터
 * @param props tab: "PROVIDER", "PARTNERS"
 * @param subTab cp, pp, msn , partners
 * @returns
 */
function ContextTotalDataContainer(props: { tab: string; subTab: string }): JSX.Element {
  // const { info } = useContentsTabListLoad(props.subTab);
  const { info } = useSelectorEq((state: IState) => ({
    info: state.calculate.contents[props.subTab].info,
  }));

  const commonData = [
    { text: "총 매출", value: info ? info.total_sales : 0 },
    { text: "최종 이익금", value: info ? info.total_calculate : 0 },
  ];
  const cpData = [
    { text: "PP 정산", value: info ? info.pp_settlement : 0 },
    { text: "PP 이익금", value: info ? info.pp_calculate : 0 },
    { text: "CP 정산", value: info ? info.cp_settlement : 0 },
    ...commonData,
  ];

  const msnData = [
    { text: "MSN 이익금", value: info ? info.msn_calculate : 0 },
    { text: "CP 정산", value: info ? info.cp_settlement : 0 },
    { text: "최종 이익금", value: info ? info.total_calculate : 0 },
  ];

  const mediaData = [{ text: "총 조회수", value: info ? info.total_page_view : 0 }, ...commonData];

  const viewData = props.tab === ActiveType.CP ? (props.subTab === "msn" ? msnData : cpData) : mediaData;

  return (
    <TotalDataWrap liCount={props.subTab === "cp" ? 5 : 3}>
      <ElementGroup.Row style={{ width: "100%" }}>
        <ul className="total-data-text__ul">
          {viewData.map((item, index) => (
            <li key={index}>
              <span>{item.text}</span>
              <span>{item.value ? <NumberCountAnimation num={item.value} text={"원"} duration={500} /> : "0원"}</span>
            </li>
          ))}
        </ul>
      </ElementGroup.Row>
    </TotalDataWrap>
  );
}

/**
 * 요율 변경 버튼 component, 클릭 시 요율변경 팝업 open
 * @returns
 */
function RatioPopupWrap(props: { tab: string; subTab: string }) {
  const { showCalculateRatioPopup } = useCalculateRatioPopup(props.subTab);
  return (
    <Button
      btnSize={ButtonSize.XSM}
      color={"dark"}
      // disabled={checkList.length > 0 ? false : true}
      text="요율 선택 적용"
      thin
      onClick={() => showCalculateRatioPopup()}
    />
  );
}

/**
 * 탭 타입에 따른 정산금 그리드 데이터 (현재는 콘텐츠 타입 일 경우에만 사용)
 * @returns
 */
function ContentsListContainer(props: { tab: string; subTab: string }) {
  const { viewList, total } = useContentsTabListLoad(props.subTab);

  const { change } = useTaxSelectChange();
  // //sub탭이 pp일 경우 보여질 grid 데이터
  // const ppGridData: IGridSetting<IContentsChannelInfoVo>[] = [
  //   {
  //     header: "채널명",
  //     id: ["code", "name"],
  //     width: "30%",
  //     element: GridCheckboxCell,
  //   },
  //   {
  //     header: "CP 요율(%)",
  //     id: ["code", "ratio"],
  //     width: "10%",
  //     element: GridRatioStringCell,
  //   },
  //   {
  //     header: "등록일",
  //     id: ["created_at"],
  //     width: "40%",
  //     element: GridDateCell,
  //   },
  //   {
  //     header: "마지막 수정일",
  //     id: ["updated_at"],
  //     width: "20%",
  //     element: GridDateCell,
  //   },
  // ];

  return (
    <CalculateTableWrapper>
      {viewList.length > 0 ? (
        <>
          <div className="table-wrap">
            <table className="grid-data-table">
              <thead>
                <tr>
                  <th>사업자명</th>
                  <th>채널명</th>
                  <th>조회수</th>
                  <th>발생 매출</th>
                  {props.tab === ActiveType.CP && (
                    <>
                      <th>CP 요율(%)</th>
                      <th>CP 정산금</th>
                      <th>추가 정산금</th>
                    </>
                  )}
                  <th>최종 합계</th>
                  {props.tab === ActiveType.CP && (
                    <>
                      <th>단가</th>
                      <th>세금계산서</th>
                      <th>지급</th>
                      <th>메모</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {viewList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.business_name ? item.business_name : "-"}</td>
                      <td className="colSpan" colSpan={props.tab === ActiveType.CP ? 8 : 4}>
                        {item.list.map((i, idx) => {
                          return (
                            <div className="td-detail" key={idx}>
                              <div>{i.name}</div>
                              <GridLocalStringRightTextCell value={i.page_view} />
                              <GridLocalStringRightTextCell value={i.sales} />

                              {props.tab === ActiveType.CP && (
                                <>
                                  <GridRatioStringCell
                                    data={{ user_id: item.user_id, code: i.code, value: i.ratio, row_num: idx }}
                                  />
                                  <GridLocalStringRightTextCell value={i.settlement} />
                                  <GridInputSaleDataCell
                                    data={{
                                      user_id: item.user_id,
                                      code: i.code,
                                      value: i.add_settlement,
                                      row_num: idx,
                                    }}
                                  />
                                </>
                              )}
                              <GridLocalStringRightTextCell value={i.calculate} />
                              {props.tab === ActiveType.CP && <GridLocalStringRightTextCell value={i.unit_price} />}
                            </div>
                          );
                        })}
                      </td>
                      {/* <td>{item.tax_status}</td> */}

                      {props.tab === ActiveType.CP && (
                        <>
                          <StatusTd type={item.tax_status === "ISSUE" ? "ok" : "not"}>
                            <UiSelectBox
                              id={`calculate_tax_${item.user_id}`}
                              data={[
                                {
                                  id: "ISSUE",
                                  value: "ISSUE",
                                  text: "발행",
                                },
                                {
                                  id: "NOT_ISSUE",
                                  value: "NOT_ISSUE",
                                  text: "미발행",
                                },
                              ]}
                              selectId="value"
                              selectType="id"
                              size="sm"
                              displayType="new"
                              change={v => change(props.subTab, "tax", item.user_id, v)}
                              init={item.tax_status}
                            />
                          </StatusTd>
                          <StatusTd
                            type={
                              item.pay_status === "COMPLETED" ? "ok" : item.pay_status === "IN_COMPLETED" ? "not" : ""
                            }
                          >
                            <UiSelectBox
                              id={`calculate_pay_${item.user_id}`}
                              data={[
                                {
                                  id: "COMPLETED",
                                  value: "COMPLETED",
                                  text: "지급완료",
                                },
                                {
                                  id: "IN_COMPLETED",
                                  value: "IN_COMPLETED",
                                  text: "미지급",
                                },
                                {
                                  id: "DIFFERENT",
                                  value: "DIFFERENT",
                                  text: "금액상이",
                                },
                              ]}
                              selectId="value"
                              selectType="id"
                              size="sm"
                              displayType="new"
                              change={v => change(props.subTab, "pay", item.user_id, v)}
                              init={item.pay_status}
                            />
                          </StatusTd>
                          <td>
                            <GridInputMemoCell subTab={props.subTab} id={item.user_id} memo={item.message} />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <TotalTableRow>
              <table className="grid-total-table">
                <tbody>
                  <tr>
                    {props.tab === ActiveType.CP ? (
                      <>
                        <td colSpan={2}>합계</td>
                        <td>{numberComma(total ? total.page_view : 0)}</td>
                        <td>{numberComma(total ? total.sales : 0)}</td>
                        <td></td>
                        <td>{numberComma(total ? (total.cp_settlement as number) : 0)}</td>
                        <td>{numberComma(total ? (total.add_settlement as number) : 0)}</td>
                        <td>{numberComma(total ? total.calculate : 0)}</td>
                        <td colSpan={4}></td>
                      </>
                    ) : (
                      <>
                        <td colSpan={2}>합계</td>
                        <td>{numberComma(total ? total.page_view : 0)}</td>
                        <td>{numberComma(total ? total.sales : 0)}</td>
                        <td>{numberComma(total ? total.calculate : 0)}</td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </TotalTableRow>
          </div>
        </>
      ) : (
        <div
          style={{
            borderTop: "1px solid var(--border-normal)",
            borderBottom: "1px solid var(--border-normal)",
            padding: "30px 0",
            textAlign: "center",
            color: "#777",
          }}
        >
          데이터가 없습니다.
        </div>
      )}
    </CalculateTableWrapper>
  );
}

/**
 * 서브 탭이 "정산금" 일 경우
 * @param props 대분류 탭
 * @returns
 */
function SettlementListContainer(props: { list: ISettlementListVo[] }) {
  return (
    <>
      <Grid
        id={`settlement_grid_data`}
        container={LeftTableContainer}
        emptyInfo={{
          element: GridEmpty,
          props: { text: "데이터가 없습니다." },
        }}
        setting={[
          {
            header: "채널명",
            id: ["name"],
            element: GridLeftTextCell,
          },

          {
            header: "정산금",
            id: ["settlement"],
            element: GridLocalStringCell,
          },
          { header: "조회수", id: ["page_count"], element: GridLocalStringCell },
        ]}
        data={props.list}
        layoutOverflow
      />
    </>
  );
}

/**
 * 파트너스 탭 일 경우 grid 데이터
 * @param props
 * @returns
 */
// function PartnersGridListContainer(props: { tab: string; subTab: string }) {
//   const { list, total } = useContentsTabListLoad(props.subTab);
//   useContentsTabListInit(props.tab, props.subTab);

//   //sub탭이 cp, msn일 경우 보여질 grid 데이터
//   const GridData: IGridSetting<IContentsChannelGirdListVo>[] = [
//     {
//       header: "채널명",
//       id: ["code", "name"],
//       width: "14%",
//       element: GridCheckboxCell,
//     },
//     {
//       header: "페이지 뷰",
//       id: ["page_view"],
//       width: "10%",
//       element: GridLocalStringRightTextCell,
//     },
//     {
//       header: "발생 매출",
//       id: ["sales"],
//       width: "12%",
//       element: GridLocalStringRightTextCell,
//     },
//     {
//       header: "PN 요율(%)",
//       id: ["code", "ratio"],
//       width: "8%",
//       element: GridRatioStringCell,
//     },
//     {
//       header: "PN 정산금",
//       id: ["settlement"],
//       width: "12%",
//       element: GridLocalStringRightTextCell,
//     },
//     {
//       header: "추가 정산금",
//       id: ["code", "add_settlement"],
//       width: "10%",
//       element: GridInputSaleDataCell,
//     },
//     {
//       header: "최종 합계",
//       id: ["calculate"],
//       width: "12%",
//       element: GridLocalStringRightTextCell,
//     },
//     {
//       header: "단가",
//       id: ["unit_price"],
//       width: "8%",
//       element: GridLocalStringRightTextCell,
//     },
//     {
//       header: "메모",
//       id: ["code", "message"],
//       width: "14%",
//       element: GridInputMemoCell,
//     },
//   ];

//   return (
//     <GridWrapper total={true}>
//       <Grid
//         id={`${props.tab}_${props.subTab}_grid`}
//         container={TableContainer}
//         emptyInfo={{
//           element: GridEmpty,
//           props: { text: "등록된 데이터가 없습니다." },
//         }}
//         setting={GridData}
//         data={list}
//         layoutOverflow
//       />
//     </GridWrapper>
//   );
// }

/**
 * 콘텐츠 탭 일 경우
 */
function ContentsContainer(props: { tab: string; subTab: string }) {
  useContentsTabListInit(props.tab, props.subTab);
  const { excelViewList } = useSettlementPageInit();

  return (
    <>
      <OptionHeader align={false}>
        <>
          <ChannelSearchOption tab={props.tab} subTab={props.subTab} />
          <DateSearchOption tab={props.tab} subTab={props.subTab} />
          <ContextTotalDataContainer tab={props.tab} subTab={props.subTab} />
        </>
      </OptionHeader>
      {/* 콘텐츠 */}
      {/* {props.tab === ActiveType.CP ? (
        <ContentsListContainer tab={props.tab} subTab={props.subTab} />
      ) : (
        // 음원영상
        <SettlementListContainer tab={props.tab} subTab={props.subTab} />
      )} */}

      {props.tab === ActiveType.CON && excelViewList && excelViewList?.length > 0 ? (
        <SettlementListContainer list={excelViewList} />
      ) : (
        <ContentsListContainer tab={props.tab} subTab={props.subTab} />
      )}
    </>
  );
}

/**
 * 파트너스 탭 일 경우
 */
function PartnersContainer(props: { tab: string; subTab: string }) {
  return (
    <>
      <OptionHeader align={false}>
        <DateSearchOption tab={props.tab} subTab={props.subTab} />
        <ContextTotalDataContainer tab={props.tab} subTab={props.subTab} />
      </OptionHeader>
      {/* <PartnersGridListContainer tab={props.tab} subTab={props.subTab} /> */}
    </>
  );
}

/**
 * 인사이트 tabMenu, activeTab에 맞는 컴포넌트 반환
 * @returns JSX.Element
 */
function SalesTabMenu(props: { tab: string }): JSX.Element {
  // const { tab } = useCalculateTabAction();

  const { subTab, tabChange } = useSubTabAction(props.tab);
  const cpSubList = [
    { id: "msn", text: "MSN CP" },
    { id: "cp", text: "ViewUs CP" },
  ];
  const mediaSubList = [{ id: "sales", text: "정산금" }];

  const partnersSubList = [
    { id: "partners", text: "Partners" },
    { id: "pp", text: "ViewUs PP" },
  ];

  const ComponentRender = () => {
    switch (props.tab) {
      case ActiveType.CP:
      case ActiveType.CON:
        return <ContentsContainer tab={props.tab} subTab={subTab} />;
      // return <MediaContainer tab={props.tab} subTab={subTab} />;
      case ActiveType.PN:
        return <PartnersContainer tab={props.tab} subTab={subTab} />;
    }
  };
  return (
    <>
      <NewTabMenuStyle>
        <TabMenu
          list={props.tab === ActiveType.CP ? cpSubList : props.tab === ActiveType.CON ? mediaSubList : partnersSubList}
          active={subTab}
          click={value => tabChange(value)}
        />
      </NewTabMenuStyle>

      {ComponentRender()}
    </>
  );
}

/**
 * 월별 확정 정산
 * @returns JSX.Element
 */
export function CalculatePages(): JSX.Element {
  const { tab } = useParams();
  const { tabChange } = useCalculateTabAction();

  useEffect(() => {
    if (tab === "provider" || tab === "media" || tab === "partners") {
      tabChange(tab.toUpperCase());
    }
  }, [tab]);
  return (
    <Fragment>
      {tab === "provider" || tab === "media" || tab === "partners" ? (
        <SalesTabMenu tab={tab.toLocaleUpperCase()} />
      ) : (
        <NotFound />
      )}
    </Fragment>
  );
}
export default CalculatePages;
